import { TerminImage } from '@/domain/termine/components/TerminImage';
import { Termin } from '@/domain/termine/shared/types/Termin';
import {
  getWiederholungStringFromTerminWiederholung,
  TerminWiederholung,
} from '@/domain/termine/shared/types/TerminWiederholung';
import { cn } from '@/lib/utils';
import { faArrowsRepeat } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Drawer, DrawerContent, DrawerTrigger } from '@/components/ui/drawer';
import { TerminInfo } from '@/domain/termine/features/Calendar/shared/TerminInfo/TerminInfo';
import { Button } from '@/components/ui/button';

/* eslint-disable max-lines-per-function */
export function ListTerminDrawer({ termin }: { termin: Termin }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setOpen(true);
  };

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen);
  };

  const showRepeatIcon =
    termin.wiederholung !== TerminWiederholung.OHNE &&
    termin.wiederholung !== TerminWiederholung.TAEGLICH;

  return (
    <Drawer open={open} onOpenChange={handleOpenChange} modal>
      <DrawerTrigger asChild>
        <div
          onClick={handleClick}
          className={cn(
            'flex items-center p-2 text-sm cursor-pointer',
            'text-neutrals-N900 bg-neutrals-N100 w-full rounded-lg',
            'shadow-sm hover:bg-neutrals-N300 transition-colors gap-2',
          )}>
          <TerminImage
            bildUrl={termin.image?.url}
            bildName={termin.image?.name}
            markierung={termin.markierung}
            variant="list"
          />
          <div className="flex flex-col justify-center">
            <span className="truncate">{termin.titel}</span>
            <span className="text-xs text-neutrals-N800 flex items-center gap-1 w-full">
              {termin.beginn && dayjs(termin.beginn).format('HH:mm')}
              {showRepeatIcon && (
                <FontAwesomeIcon
                  icon={faArrowsRepeat}
                  aria-label={t('domain.termine.repeat', {
                    wiederholung: getWiederholungStringFromTerminWiederholung(
                      termin.wiederholung,
                    ).toLowerCase(),
                  })}
                  className="text-neutrals-N700"
                />
              )}
            </span>
          </div>
        </div>
      </DrawerTrigger>
      <DrawerContent className="z-[60] rounded-t-2xl pb-6">
        <div className="flex justify-center pt-2">
          <div className="h-1 w-12 rounded-full bg-neutrals-N300" />
        </div>
        <div className="w-full py-5 pl-5">
          <TerminInfo termin={termin} />
        </div>
        <div className="sticky bottom-0 flex flex-col gap-3 px-5 py-4 ">
          <Button size="sm" variant="default">
            <span>{t('domain.termine.edit')}</span>
          </Button>
          <Button size="sm" variant="ghost-destructive">
            <span>{t('domain.termine.delete')}</span>
          </Button>
        </div>
      </DrawerContent>
    </Drawer>
  );
}
